import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import InternetLobbyProductsListBlockData from 'app/Models/Content/InternetLobbyProductsListBlockData';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import React from 'react';
import {Container} from 'reactstrap';

const InternetLobbyProductsListBlock = (props: ComponentProps<InternetLobbyProductsListBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props}>
      <div className='InternetLobbyProductsListBlock'>
        <Container className='col'>
          <ContentArea noWrap data={data.internetLobbyProducts} context={context} />
        </Container>
      </div>
    </BlockWrapper>
  );
};

export default InternetLobbyProductsListBlock;
